import { useUnsafeCurrentUserContext } from "@/domain/user/hooks/use-current-user-context";
import { isModuleActionAllowed, ModuleAction, ProductModule } from "@ark/shared";

import { useCurrentAccountType } from "./use-current-account-type";

interface UseCanModuleActionProps {
  module: ProductModule;
  action: ModuleAction;
}

// Client-side mirror of the backend seat-tier fence: asks the shared capability
// matrix (the same function the server uses, so it is not a reimplementation)
// whether the current member's tier permits the action in the module. The server
// enforces regardless; this only avoids offering a control that would fail.
// Superusers always pass; with no context the tier defaults to CORE (allow).
export function useCanModuleAction({ module, action }: UseCanModuleActionProps): boolean {
  const isSuperUser = useUnsafeCurrentUserContext()?.isSuperUser ?? false;
  const accountType = useCurrentAccountType();

  if (isSuperUser) {
    return true;
  }
  return isModuleActionAllowed({ accountType, module, action });
}
